import { ImageSize } from './image-size';
import { Size } from './size';
import { ViewportSize } from './viewport-size';

const aspectRatio = (x: number, y: number): number => x / y;
const toPixels = (n: number) => `${n}px`;

export const resizeImage = (imageSize: Size, viewportSize: ViewportSize): ImageSize => {
  const naturalImageWidth = imageSize.width;
  const naturalImageHeight = imageSize.height;

  let imageWidth = naturalImageWidth;
  let imageHeight = naturalImageHeight;

  if (!viewportSize.contains(imageSize)) {
    // Size down the image while maintaining the aspect ratio.
    if (aspectRatio(naturalImageWidth, viewportSize.width) > aspectRatio(naturalImageHeight, viewportSize.height)) {
      imageWidth = viewportSize.width;
      imageHeight = Math.floor((viewportSize.width * naturalImageHeight) / naturalImageWidth);
    } else {
      imageHeight = viewportSize.height;
      imageWidth = Math.floor((viewportSize.height * naturalImageWidth) / naturalImageHeight);
    }
  }

  return {
    naturalWidth: naturalImageWidth,
    naturalHeight: naturalImageHeight,
    width: toPixels(imageWidth),
    height: toPixels(imageHeight)
  };
};
